import React from 'react';
import { useInput, useTranslate } from 'react-admin';

const TimeInput = ({ source, label }) => {
	const translator = useTranslate();

	const {
		input: { value, onChange },
	} = useInput({ source });

	const handleTimeChange = (event) => {
		onChange(event.target.value);
	};

	const labelStyle = {
		marginRight: '8px',
	};

	const divStyle = {
		marginBottom: '15px',
	};

	const inputStyle = {
		// Add your input styles here
		padding: '6px',
		borderRadius: '4px',
		border: '1px solid #ccc',
	};

	return (
		<div style={divStyle}>
			<label style={labelStyle}>{translator(label)}</label>
			<input
				type="time"
				value={value || ''}
				onChange={handleTimeChange}
				style={inputStyle}
			/>
		</div>
	);
};

export default TimeInput;
